import { render } from "./Maintenance.vue?vue&type=template&id=5e419084"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/globals/Maintenance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e419084"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e419084', __exports__)) {
    console.log('reload')
    api.reload('5e419084', __exports__)
  }
  
  module.hot.accept("./Maintenance.vue?vue&type=template&id=5e419084", () => {
    console.log('re-render')
    api.rerender('5e419084', render)
  })

}


export default __exports__